import { Link, Stack, Text } from "@seneca/senekit";

import { linkToUnblockSchoolNetworkArticle } from "common/links";

import { linkToPersonalInformation } from "features/dashboard/pages/settings-page/links";

export default function HelpBulletPoints() {
  return (
    <ul>
      <Stack space={["small", "medium"]}>
        <BulletPointItem>
          Make sure you're logged into the <strong>account</strong> and{" "}
          <strong>device</strong> you're experiencing issues with.{" "}
          <Link to={linkToPersonalInformation()}>Check here</Link> to ensure
          you're using the correct login
        </BulletPointItem>

        <BulletPointItem>
          If you are working at school this could be due to your school network
          blocking some of the things Seneca needs to work.{" "}
          <Link to={linkToUnblockSchoolNetworkArticle("en")}>
            Share this link&nbsp;
          </Link>
          with an IT technician at your school to help them fix it
        </BulletPointItem>
      </Stack>
    </ul>
  );
}

function BulletPointItem({ children }: { children: React.ReactNode }) {
  return (
    <li>
      <Text>{children}</Text>
    </li>
  );
}
